import { render, staticRenderFns } from "./LocationsList.vue?vue&type=template&id=459dfcfc&"
import script from "./LocationsList.vue?vue&type=script&lang=js&"
export * from "./LocationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports